import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SubscriptionListTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function SubscriptionListTab() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingSubscription, setEditingSubscription] = useState(null);
  const [formData, setFormData] = useState({ name: '', description: '', tariff_name: '' });

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchSubscriptions = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/subscriptions`);
      setSubscriptions(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке подписок: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingSubscription) {
        await axios.put(`${API_URL}/api/subscriptions/${editingSubscription.id}`, formData);
      } else {
        await axios.post(`${API_URL}/api/subscriptions`, formData);
      }
      setShowForm(false);
      setEditingSubscription(null);
      setFormData({ name: '', description: '', tariff_name: '' });
      fetchSubscriptions();
    } catch (err) {
      setError('Ошибка при сохранении подписки: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleEdit = (subscription) => {
    setEditingSubscription(subscription);
    setFormData({
      name: subscription.name,
      description: subscription.description,
      tariff_name: subscription.tariff_name
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту подписку? Все связанные тарифы также будут удалены.')) {
      try {
        await axios.delete(`${API_URL}/api/subscriptions/${id}`);
        fetchSubscriptions();
      } catch (err) {
        setError('Ошибка при удалении подписки: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingSubscription(null);
    setFormData({ name: '', description: '', tariff_name: '' });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="subscription-list-tab">
      <div className="tab-header">
        <h3>Управление подписками</h3>
        {!showForm && (
          <button className="btn btn-primary" onClick={() => setShowForm(true)}>
            + Добавить подписку
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <div className="form-container">
          <h4>{editingSubscription ? 'Редактировать подписку' : 'Добавить новую подписку'}</h4>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Название подписки *</label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                maxLength={255}
                placeholder="Введите название подписки"
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Описание *</label>
              <textarea
                id="description"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                required
                rows={4}
                placeholder="Введите описание подписки"
              />
            </div>
            <div className="form-group">
              <label htmlFor="tariff_name">Название тарифа *</label>
              <input
                type="text"
                id="tariff_name"
                value={formData.tariff_name}
                onChange={(e) => setFormData({ ...formData, tariff_name: e.target.value })}
                required
                maxLength={255}
                placeholder="Введите название тарифа"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingSubscription ? 'Сохранить' : 'Создать'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Описание</th>
              <th>Название тарифа</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {subscriptions.length === 0 ? (
              <tr>
                <td colSpan="5" className="empty-state">
                  Нет подписок. Добавьте первую подписку.
                </td>
              </tr>
            ) : (
              subscriptions.map((subscription) => (
                <tr key={subscription.id}>
                  <td>{subscription.id}</td>
                  <td>{subscription.name}</td>
                  <td className="description-cell">{subscription.description}</td>
                  <td>{subscription.tariff_name}</td>
                  <td>
                    <button
                      className="btn-icon btn-edit"
                      onClick={() => handleEdit(subscription)}
                      title="Редактировать"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(subscription.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SubscriptionListTab;

